import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// The support team's Telegram Mini App lives under /tg/ in this same bundle,
// but it is a different application: no Telos session, no sidebar, no
// language-keyed remount, and its own router. Branching here — before <App/>
// mounts — keeps useFindUser from probing /auth/me/ inside Telegram (a stale
// token there ends in a redirect to /login, which a WebView cannot use) and
// keeps App's catch-all route from bouncing /tg/… back to "/".
const SupportMiniApp = lazy(() => import("./pages/SupportMiniApp/SupportMiniApp"));
const isMiniApp = window.location.pathname.startsWith("/tg/");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isMiniApp ? (
      <Suspense fallback={null}>
        <SupportMiniApp />
      </Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
